/* eslint-disable no-magic-numbers */
import { Component, computed, inject, input, OnInit, signal } from '@angular/core';
import { OfferListComponent } from './components/offer-list/offer-list.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { TncBasicComponent } from '../tnc-basic/tnc-basic.component';
import { LoaderComponent } from '@shared/components/loader/loader.component';
import { OfferListData } from './components/offer-list/offer-list';
import { GetPackageDto, GetPackageResp } from '@usecase/package/get-package/get-package.interface';
import { GetPackageUsecase } from '@usecase/package/get-package/get-package.usecase';
import { DialogService } from '@shared/component.dialog';
import { PoinListDto, PoinListResp } from '@usecase/poin/poin.type';
import { GetPoinListUseCase } from '@usecase/poin/get-poin-list.usecase';
import { PromoObject } from '@usecase/content/get-content.interface';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GetCustParamResp } from '@usecase/cust-param/get-cust-param.type';
import { GetCustParamUsecase } from '@usecase/cust-param/get-cust-param.usecase';
import { GetClaimVoucherUsecase } from '@usecase/voucher/get-claim-voucher/get-claim-voucher.usecase';
import { GetClaimVoucherDto, GetClaimVoucherResp } from '@usecase/voucher/get-claim-voucher/get-claim-voucher.type';
import { AdditionalHeader } from '@presentation/landing/landing';
import { OtpComponent } from '../otp/otp.component';
import { PromoType, ValidateHaloNumber } from '@data/domain/promo.entity';
import { InputMsisdnComponent } from './components/input-msisdn/input-msisdn.component';
import { TokenStateService } from '@shared/services/token-state/token-state.service';
import { take } from 'rxjs';
import { TokenStateActive } from '@shared/services/token-state/token-state.interface';
import { MigrateHaloComponent } from './components/migrate-halo/migrate-halo.component';
import { RequestOtpV3Usecase } from '@usecase/otp/request-otp-v3/request-otp-v3.usecase';
import { RequestOtpV3Dto, RequestOtpV3Resp } from '@usecase/otp/request-otp-v3/request-otp-v3.type';
import { PostValidateHaloNumberUsecase } from '@usecase/voucher/post-validate-halo-number/post-validate-halo-number.usecase';
import { PostValidateHaloNumberDto, PostValidateHaloNumberResp } from '@usecase/voucher/post-validate-halo-number/post-validate-halo-number.type';
import { Button, ErrorModal } from '@shared/components/error-modal/error-modal.interface';
import { ErrorModalComponent } from '@shared/components/error-modal/error-modal.component';
import { ErrorMessage } from '@shared/services/error-message/error-message.interface';
import { GtmTrackingService } from '../../../../shared/services/gtm-tracking.service';
const OTP_COUNT = 6;

@Component({
  selector: 'check-offers',
  standalone: true,
  imports: [
    OfferListComponent,
    ReactiveFormsModule,
    NgClass,
    TncBasicComponent,
    NgTemplateOutlet,
    LoaderComponent,
    InputMsisdnComponent,
    MigrateHaloComponent
  ],
  templateUrl: './check-offers.component.html',
  styleUrl: './check-offers.component.scss'
})
export class CheckOffersComponent implements OnInit {
  data = input<PromoObject>();
  categoryType = input<string>();

  offerListResult = signal<OfferListData>({
    packages: [],
    poins: []
  });
  initialize = signal<boolean>(false);
  queryParams = signal<Params>({});
  valid = signal<boolean>(true);
  validateHaloNumberData = signal<ValidateHaloNumber | null>(null);
  promoType = signal<PromoType>(localStorage.getItem('promoType') as PromoType);
  campaignId = signal<string>('');

  isLoadOffer = signal<boolean>(false);
  isMsisdnClaimVoucher = signal<boolean>(false);
  isAffiliatePackage = signal<boolean>(false);

  contextDataButton = computed(() => {
    return {
      text: this.data()?.button_text,
      promoType: this.promoType()
    };
  });

  msisdn!: FormControl;

  public dialogService = inject(DialogService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly getPackageUsecase = inject(GetPackageUsecase);
  private readonly getPoinListUsecase = inject(GetPoinListUseCase);
  private readonly getCustParamUsecase = inject(GetCustParamUsecase);
  private readonly getClaimVoucherUsecase = inject(GetClaimVoucherUsecase);
  private readonly postValidateHaloNumberUsecase = inject(PostValidateHaloNumberUsecase);
  private readonly requestOtpV3Usecase = inject(RequestOtpV3Usecase);
  private readonly tokenStateService = inject(TokenStateService);
  private readonly gtmTrackingService = inject(GtmTrackingService);

  ngOnInit(): void {
    this.initializeMsisdnFormControl();
    this.getQueryParams();
    this.handlePromoType();
  }

  handlePromoType() {
    switch (this.promoType()) {
      case 'claimVoucher':
        this.handleRequestMsisdn();
        break;
      case 'affiliate':
        this.handleGetPackageAffiliate('0');
        break;
      default:
        this.handleGetPackagePromo('0');
        break;
    }
  }

  getCustomerMsisdn() {
    this.tokenStateService.selectedToken$.pipe(take(1)).subscribe({
      next: (res: TokenStateActive | null) => {
        if (res) {
          const payload: PostValidateHaloNumberDto = {
            msisdn: res.cust_msisdn,
            authId: res.auth_id,
            token_otp: res.token,
            verifySimcard: true
          };

          this.validateHaloNumber(payload);

          this.msisdn.setValue(res.cust_msisdn?.replace('62', '0'));
        }
      }
    });
  }

  // The initializeMsisdnFormControl method is being overused. Consider refactoring by creating a utility function for form control initialization.

  initializeMsisdnFormControl() {
    this.msisdn = new FormControl('');
  }

  getQueryParams() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.queryParams.set(params);

      if (params['custParam'] !== undefined) {
        this.getCustParamData();
      }
    });
  }

  onClickResetInput() {
    this.msisdn.setValue('');

    // RESET PACKAGE OR POINS PACKAGE
    this.offerListResult.set({
      packages: [],
      poins: []
    });

    // RESET MIGRATE HALO DATA
    this.validateHaloNumberData.set(null);
    this.isLoadOffer.set(false);

    // Track reset action
    this.gtmTrackingService.trackButtonClick('Reset Input', 'Check Offers');
  }

  onClickCheckMsisdn() {
    // Track check MSISDN action
    this.gtmTrackingService.trackButtonClick(`Check ${this.promoType()}`, 'Check Offers');

    if (this.promoType() === 'claimVoucher') {
      const { keyword, outlet, code } = this.queryParams();
      const isClaimVoucherWithParams = this.promoType() === 'claimVoucher' && keyword && outlet && code;

      if (isClaimVoucherWithParams && this.isMsisdnClaimVoucher()) return this.handleRequestTokenClaimVoucher();
      if (isClaimVoucherWithParams && !this.isMsisdnClaimVoucher()) return this.requestOtpV3();
    }


    if (this.promoType() === 'affiliate') return this.handleGetPackageAffiliate(this.msisdn.value);
    if (this.promoType() === 'poin') return this.getPoins(this.msisdn?.value);
    if (this.promoType() === 'migrateHalo') return this.requestOtpV3();
    this.handleGetPackagePromo(this.msisdn?.value);
  }

  getCustParamData() {
    const header: AdditionalHeader[] = [
      {
        key: 'custParam',
        value: this.queryParams()['custParam']
      }
    ];

    this.getCustParamUsecase.execute(header).subscribe({
      next: (res: GetCustParamResp) => {
        const { msisdn } = res.data;
        this.msisdn?.setValue(msisdn);
        this.initialize.set(false);
        if (this.promoType() !== 'affiliate') return this.handleGetPackagePromo(msisdn);
        if (this.promoType() === 'affiliate') return this.handleGetPackageAffiliate(msisdn);
      }
    });
  }

  getPackages(payload: GetPackageDto) {
    this.isLoadOffer.set(true);
    this.getPackageUsecase.execute(payload, this.promoType()).pipe(take(1)).subscribe({
      next: (res: GetPackageResp) => {
        this.campaignId.set(res?.campaignid[0]);
        if (res.msisdn) this.msisdn.setValue(res.msisdn.toString().replace('62', '0'));
        this.offerListResult.set({
          packages: res.package_list,
          poins: []
        });
        this.isAffiliatePackage.set(res.isAffiliate);
        this.isLoadOffer.set(false);

        // Track successful package load
        this.gtmTrackingService.trackPackageListView(
          res.package_list,
          this.data()?.ML || 'promo_packages',
          `${this.promoType()} Packages`,
          this.promoType()
        );
      },
      error: (error: ErrorMessage) => {
        this.isLoadOffer.set(false);
        if (error.msisdn && error.msisdn !== '0') {
          this.msisdn.setValue(error.msisdn.replace('62', '0'));
          this.openErrorModal(error, () => this.getPackages(payload));
          return;
        }

        if(this.msisdn.value !== '') this.openErrorModal(error);

        // Track error
        this.gtmTrackingService.trackError(
          error.description || 'Unknown error',
          'Package Load Error'
        );
      }
    });
  }

  handleGetPackagePromo(msisdn: string) {
    const payload: GetPackageDto = {
      msisdn: this.handleReplace(msisdn),
      menulevel: this.data()?.ML ?? '',
      packagetype: 'promo',
      initialize: msisdn === '0'
    };

    this.getPackages(payload);
  }

  handleGetPackageAffiliate(msisdn: string) {
    const { utm_id } = this.queryParams();
    const payload: GetPackageDto = {
      msisdn: this.handleReplace(msisdn),
      menulevel: this.data()?.ML ?? '',
      packagetype: 'promo',
      initialize: msisdn === '0',
      promoName: this.activatedRoute.snapshot.params['content'],
      referralCode: utm_id
    };

    this.getPackages(payload);
  }

  handleReplace(msisdn: string): number {
    return msisdn === '0' ? 0 : Number(msisdn.replace('0', '62'));
  }

  getPoins(msisdn: string) {
    this.isLoadOffer.set(true);
    const payload: PoinListDto = {
      msisdn: msisdn?.replace(/^0/, '62'),
      category: this.categoryType() ?? ''
    };

    this.getPoinListUsecase.execute(payload).subscribe({
      next: (res: PoinListResp) => {
        this.offerListResult.set({
          poins: res.list_poin,
          packages: []
        });
      },
      error: (error: ErrorMessage) => {
        this.openErrorModal(error, () => this.onClickResetInput());
      },
      complete: () => {
        this.isLoadOffer.set(false);
      }
    });
  }

  getClaimVoucher(payload: GetClaimVoucherDto, action: 'get-msisdn' | 'get-token') {
    this.getClaimVoucherUsecase.execute(payload).subscribe({
      next: (res: GetClaimVoucherResp) => {

        if (action === 'get-msisdn' && res.msisdn) {
          this.msisdn.setValue(res.msisdn);
          this.msisdn.disable();
          this.isMsisdnClaimVoucher.set(true);
        }

        if (action === 'get-token') this.router.navigate(['invoice-claim/success']);
      },
      error: () => {
        if (action === 'get-msisdn') this.isMsisdnClaimVoucher.set(false);
        if (action === 'get-token') this.router.navigate(['invoice-claim/failed']);
      }
    });
  }

  handleRequestTokenClaimVoucher() {
    const { keyword, outlet, code } = this.queryParams();

    const payload: GetClaimVoucherDto = {
      msisdn: this.msisdn?.value,
      keyword: keyword,
      token: '',
      outlet: outlet,
      voucher_code: code,
      initialize: true
    };

    this.getClaimVoucher(payload, 'get-token');
  }

  handleRequestMsisdn() {
    const payload: GetClaimVoucherDto = {
      initialize: false
    };

    this.getClaimVoucher(payload, 'get-msisdn');
  }

  openErrorModal(event: ErrorMessage, callback?: () => void) {
    const emptyButton: Button = {
      isBgRed: false,
      text: '',
      url: ''
    };
    const popupData: ErrorModal = {
      image: event.image,
      title: event.title,
      description: event.description,
      firstButton: event.firstButton ?? emptyButton,
      secondButton: event.secondButton ?? emptyButton
    };
    const dialogRef = this.dialogService.open(ErrorModalComponent, {
      data: popupData
    });

    dialogRef.instance().resetEvent.pipe(take(1)).subscribe(() => {
      if(callback) callback();
    });
  }

  requestOtpV3() {
    const payload: RequestOtpV3Dto = {
      msisdn: this.msisdn?.value ? this.msisdn.value.replace(/^0/, '62') : '0'
    };

    // Track OTP request
    this.gtmTrackingService.trackAuthEvent('otp_request', this.promoType());

    this.requestOtpV3Usecase.execute(payload).pipe().subscribe({
      next: (res: RequestOtpV3Resp) => {
        this.openOtp(res.data.authID);
      }
    });
  }

  openOtp(authId: string) {
    const dialogRef = this.dialogService.open(OtpComponent, {
      data: {
        msisdn: this.msisdn?.value,
        otpCount: OTP_COUNT
      }
    });

    dialogRef.instance().submitOTP.subscribe((otp: string) => {
      // Track OTP submission
      this.gtmTrackingService.trackAuthEvent('otp_submit', 'OTP Submitted');

      const payload: PostValidateHaloNumberDto = {
        token_otp: otp,
        msisdn: this.msisdn.value,
        authId: authId
      };
      this.validateHaloNumber(payload);
      dialogRef.close();
    });

    dialogRef.instance().resendOTP.subscribe(() => {
      // Track OTP resend
      this.gtmTrackingService.trackAuthEvent('otp_resend', 'OTP Resent');

      dialogRef.close();
      this.requestOtpV3();
    });
  }

  validateHaloNumber(payload: PostValidateHaloNumberDto) {
    this.postValidateHaloNumberUsecase.execute(payload).subscribe({
      next: (res: PostValidateHaloNumberResp) => {
        this.validateHaloNumberData.set(res.data);
      }
    });
  }

}
